import { FC, ReactNode, useState, useCallback, MouseEvent as RME } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Container, Text, Button, Spacer, parsers } from 'roadie-ui'
import Page from 'rui/widgets/Page'
import { BrowserRouter as Router } from 'react-router-dom'
import styled from 'styled-components'
import { capitalize } from 'util/format'

import sample from 'lodash/sample'

import fitz from 'images/dogs/fits.png'
import winnie from 'images/dogs/winnie.png'
import { LocalizedText } from 'localization'

const dogs = {
  fitz,
  winnie,
}

type Dog = {
  name: string
  url: string
}

function randomDog(): Dog {
  const name = sample(Object.keys(dogs))! as keyof typeof dogs

  return {
    name: capitalize(name),
    url: dogs[name],
  }
}

const Textarea = styled.textarea`
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  width: 100%;
  padding: 1rem;
  border-radius: 3px;
  border-color: ${parsers.borderColor.parser('neutral-light')};
  resize: none;
`

const ErrorFallback: FC<{ error: Error }> = (props) => {
  const { error } = props
  const [dog] = useState(randomDog)

  const handleSelectText = useCallback((event: RME<HTMLTextAreaElement, MouseEvent>) => {
    ;(event.target as HTMLTextAreaElement).select()
  }, [])

  return (
    // @ts-expect-error don't know what this is complaining.. figure it out later
    <Router>
      <Page>
        <Container.Grid
          $gridTemplateColumns="40rem 30rem"
          $gridTemplateColumnsMedia={{ tablet: '1fr', mobile: '1fr' }}
          $padding="5rem"
          $gridGap="10rem"
          $alignItems="center"
        >
          <div role="alert">
            <Text.H2 $color="neutral-black" $fontWeight="bold">
              <LocalizedText translationKey="dweb_rui_widgets_catch_error_ruff_stuff" />
            </Text.H2>
            <Text.Body2 $color="neutral-dark">
              <LocalizedText translationKey="dweb_rui_widgets_catch_error_we_ran_into_following_issue_please_refresh_page" />
            </Text.Body2>
            <Spacer $height="1rem" />
            <Text.Caption $color="error-light">
              <Textarea rows={6} onClick={handleSelectText}>
                {error.stack}
              </Textarea>
            </Text.Caption>
            <Spacer $height="1rem" />
            <Button.A.Primary $width="100%" href="/">
              <LocalizedText translationKey="dweb_rui_widgets_catch_error_return_home" />
            </Button.A.Primary>
          </div>
          <Container.GridItem $justifySelf="center">
            <img src={dog.url} alt={dog.name} />
            <Text.H6>
              <LocalizedText translationKey="dweb_rui_widgets_catch_error_while_youre_here_meet" />
            </Text.H6>
            <Text.H5 $textAlign="center" $color="neutral-black">
              {dog.name}
            </Text.H5>
          </Container.GridItem>
        </Container.Grid>
      </Page>
    </Router>
  )
}

const CatchError: FC<{ children: ReactNode }> = (props) => (
  <ErrorBoundary FallbackComponent={ErrorFallback}>{props.children}</ErrorBoundary>
)

export default CatchError
